module.exports = __webpack_public_path__ + "img/mappic_en_US.f33a62b3.png";